import { CircularProgress, Stack } from '@mui/material';

export default function Loading({ sx = {} }) {
  return (
    <Stack alignItems="center" justifyContent="center" sx={{ my: 10, ...sx }}>
      <CircularProgress size={30} />
    </Stack>
  );
}
